import React from 'react';
import { FaStar } from 'react-icons/fa';

// Sample data for reviews
const reviews = [
  {
    name: "Kranti Kumari",
    university: "IGNOU University",
    stars: 5,
    quote: "Grateful for the enriching experience at InternsElite during my 3-month internship. Expertly applying C, C++, and DSA in projects."
  },
  {
    name: "Sachin Gupta",
    university: "IIIT-Delhi, Electronics and VLSI Engineering",
    stars: 4,
    quote: "Through this training, I sharpened my skills in C++, a versatile programming language. I can now write more efficient and optimized code, leveraging C++ features to enhance the performance of my programs."
  },
  {
    name: "Anushka Raj",
    university: "Graphic Era Deemed to Be University BBA",
    stars: 5,
    quote: "Grateful to InternsElite for an outstanding C, C++ with DSA course. The depth, organization, and practical examples enriched my learning, ensuring valuable skills for my career. Kudos for consistently delivering top-notch education."
  },
  {
    name: "Raj Shekhar Singh",
    university: "Lucknow University",
    stars: 5,
    quote: "It was a great experience with Internselite which gave me an opportunity to do an internship with it. The internship program was very good and nice Internselite were very helpful to me throughout my whole internship program."
  },
  {
    name: "Nalamekala Sindhu",
    university: "Annamacharya Institute of Technology and Sciences, Tirupati, CSE",
    stars: 4,
    quote: "Internsellite's team demonstrated exceptional dedication, delivering high-quality results with professionalism and adaptability. Their impact on our project's success is commendable, making the collaboration a valuable experience."
  },
  {
    name: "Vedant Vishal Trivedi",
    university: "SNJB'S College of Engineering, CS",
    stars: 4,
    quote: "Complete training was really good and got to learn many things, also the soft skills sessions was really helpful to build a successful career."
  }
];

function CCD_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Says</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div className={`col-md-${index % 2 === 0 ? 5 : 7} card`} key={index}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.university}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {Array.from({ length: 5 }, (_, i) => (
                          <li key={i}>
                            <FaStar color={i < review.stars ? "gold" : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.quote}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CCD_Review_Program_Page;
